import type * as Blockly from 'blockly/core';
import { registerSdcardFile } from './helper/sdcard_helper';
import { resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const SEPARATOR_MAP: Record<string, string> = {
    COMMA: ',',
    SPACE: ' ',
    TAB: '\t',
};

export function register(gen: any): void {
    gen.forBlock['sdcard_write'] = function (block: Blockly.Block): string {
        const board = resolveBoard(block);
        const filenameBase = block.getFieldValue('FILENAME') ?? 'data_1';
        const ext = block.getFieldValue('EXT') ?? 'txt';
        // ブルー(ESP32)のSDライブラリはVFS経由のため先頭スラッシュが必須
        const filename = `"${board === 'blue' ? '/' : ''}${filenameBase.toUpperCase()}.${ext.toUpperCase()}"`;
        const mode = block.getFieldValue('MODE') ?? 'APPEND';

        const varName = registerSdcardFile(filename, mode, board);

        const liveIds = block.inputList.filter((i) => i.name.startsWith('VAL_')).map((i) => i.name.replace('VAL_', ''));
        const sepKey = (block as any)._separatorValue ?? block.getFieldValue('SEPARATOR') ?? 'COMMA';
        const sep = SEPARATOR_MAP[sepKey] ?? ',';
        const values = liveIds.map((id) => gen.valueToCode(block, `VAL_${id}`, 0) || '0');

        const lines: string[] = [`if (!${varName}) { Serial.println("[SDカード] ファイルが開いていません"); return; }`];
        values.forEach((v, i) => {
            const isLast = i === values.length - 1;
            if (isLast) {
                lines.push(`${varName}.println(${v});`);
            } else {
                lines.push(`${varName}.print(${v});`);
                lines.push(`${varName}.print("${sep}");`);
            }
        });
        lines.push(`${varName}.flush();`);

        return lines.join('\n') + '\n';
    };
}
